import '../scss/frontend.scss';
let $ = jQuery.noConflict();
import Cookies from 'js-cookie';

import { init } from './final/init';

$(function () {
	console.log('frontent.js');

	init();
});
